import React, { useState, useEffect, useRef, forwardRef } from 'react'
import clsx from 'clsx'
import { IconMaps } from '@ow/icons'
import {
  StyledMenuContent,
  StyledMenuNavItem,
  StyledMenu,
  StyledMenuFloatContent,
  StyledMenuFloatNavItem,
} from './styled/menu-first'
import RenderIf from '../../render-if'
import {
  getCurrentUrl,
  setDataHighlightState,
  isCurrentUrlChildren,
  useWindowSize,
} from '../utils'

const MenuFirst = (props, ref) => {
  const {
    menuData,
    rightComponent,
    leftComponent,
    onMenuSelect,
    secondNav,
    hiddenNavs,
    // children,
  } = props
  // 最终的menuData
  const [latestMenuData, setMenuData] = useState(menuData)
  const [secondNavData, setSecondNavData] = useState({})

  const { clientWidth, clientSize } = useWindowSize()
  const [isShowArrowBtn, setShowArrowBtn] = useState(false)
  const [rightCompsWidth, setRightCompsWidth] = useState()
  const [leftCompsWidth, setLeftCompsWidth] = useState()
  const [isShowFloatNav, setShowFloatNav] = useState(false)
  const navViewRef = useRef()

  useEffect(() => {
    const flag = false
    for (let i = 0; i < menuData.length; i++) {
      const navs = menuData[i]
      if (isCurrentUrlChildren({ navChild: navs, inputFlag: flag })) {
        setSecondNavData(navs || {})
        break
      } else setSecondNavData({})
    }

    const data = setDataHighlightState(menuData, 1)
    // const data = setDataHighlightState(menuData, isRenderAllLevel)
    setMenuData(data)
  }, [menuData])

  // 页面宽度变化时，控制上下翻页按钮是否显示
  useEffect(() => {
    if (navViewRef.current) {
      const navListWidth = Array.from(navViewRef.current.childNodes).reduce(
        (prev, cur) => {
          return prev + cur.clientWidth
        },
        0
      )
      if (navListWidth > navViewRef.current.clientWidth) setShowArrowBtn(true)
      else setShowArrowBtn(false)
    }
  }, [clientWidth, navViewRef.current && navViewRef.current.clientWidth])

  // 获取右侧组件宽度
  useEffect(() => {
    setRightCompsWidth(rightComponent.ref.current.clientWidth)
  }, [rightComponent])

  // 获取左侧组件宽度
  useEffect(() => {
    setLeftCompsWidth(
      leftComponent && leftComponent.ref
        ? leftComponent.ref.current.clientWidth
        : 0
    )
  }, [leftComponent])

  const handleNavClick = (nav) => {
    onMenuSelect(nav)
    setSecondNavData(nav || {})
  }

  // 渲染下一级导航
  const renderSecondNav = () => {
    return typeof secondNav === 'function'
      ? secondNav(secondNavData)
      : secondNav
  }

  // 上一页
  const toLeft = () => {
    navViewRef.current.scrollBy(-200, 0)
  }
  // 下一页
  const toRight = () => {
    navViewRef.current.scrollBy(200, 0)
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden" ref={ref}>
      <StyledMenu className="bg-primary-700 dark:bg-darkTheme-1100">
        {/* 展开浮动导航的按钮 */}
        {clientSize === 'small' && !hiddenNavs && (
          <div
            className={clsx([
              'float-menu-btn',
              isShowFloatNav
                ? 'float-menu-btn-active'
                : 'float-menu-btn-normal',
            ])}
            onClick={() => setShowFloatNav(!isShowFloatNav)}
          >
            <IconMaps
              type={isShowFloatNav ? 'cancel' : 'collapse'}
              width={20}
              height={20}
              fill="var(--ow-color-white-100)"
            />
          </div>
        )}

        {/* 企业信息 */}
        {leftComponent}

        {/* 中间导航部分 */}
        {/* 如果不是小屏幕，就显示横向导航 */}
        {clientSize !== 'small' && !hiddenNavs && (
          <StyledMenuContent
            style={{
              width: `calc(100% - ${leftCompsWidth}px - ${rightCompsWidth}px)`,
            }}
          >
            <RenderIf isTrue={latestMenuData}>
              {/* 往左翻 */}
              {isShowArrowBtn && (
                <div
                  className="scroll-btn left-arrow-btn"
                  onClick={() => toLeft()}
                >
                  <IconMaps
                    type="leftarrow"
                    width={16}
                    height={16}
                    fill="var(--ow-color-white-100)"
                  />
                </div>
              )}
              <div ref={navViewRef} className="menu-content flex-1">
                {latestMenuData
                  .filter((f) => f.show)
                  .map((nav) => {
                    return (
                      <StyledMenuNavItem key={nav.url}>
                        <div
                          onClick={() => handleNavClick(nav)}
                          className={clsx([
                            'nav-name',

                            nav.isActive ||
                            getCurrentUrl().includes(nav.matchUrl)
                              ? 'bg-white text-primary-700 dark:bg-primary-700 dark:text-white-100 nav-item-active'
                              : 'text-white-100',
                          ])}
                        >
                          {nav.name}
                        </div>
                      </StyledMenuNavItem>
                    )
                  })}
              </div>
              {/* 往右翻 */}
              {isShowArrowBtn && (
                <div
                  className="scroll-btn right-arrow-btn"
                  onClick={() => toRight()}
                >
                  <IconMaps
                    type="rightarrow"
                    width={16}
                    height={16}
                    fill="var(--ow-color-white-100)"
                  />
                </div>
              )}
            </RenderIf>
          </StyledMenuContent>
        )}
        {/* 如果是小屏幕 && isShowFloatNav===true，就显示浮动导航 */}
        {clientSize === 'small' && isShowFloatNav && (
          <StyledMenuFloatContent>
            {latestMenuData
              .filter((f) => f.show)
              .map((nav) => {
                return (
                  <StyledMenuFloatNavItem key={nav.url}>
                    <div
                      onClick={() => {
                        handleNavClick(nav)
                        setShowFloatNav(false)
                      }}
                      className={clsx([
                        'nav-name',
                        (nav.isActive ||
                          getCurrentUrl().includes(nav.matchUrl)) &&
                          'nav-item-active',
                      ])}
                    >
                      {nav.name}
                    </div>
                  </StyledMenuFloatNavItem>
                )
              })}
          </StyledMenuFloatContent>
        )}

        {/* 用户信息 */}
        {rightComponent}
      </StyledMenu>

      <div className="flex-1 flex overflow-hidden">{renderSecondNav()}</div>
    </div>
  )
}

export default forwardRef(MenuFirst)
